import Vue from 'vue';
import axios from 'axios';
// import wx from 'weixin-js-sdk';
import FastClick from 'fastclick';
import utils from '@/services/utils';
import LyTab from 'ly-tab';
import App from './App';
import router from './router';
import store from './store';

Vue.use(LyTab);

require('weui');

const useragent = navigator.userAgent;
// 获取ios设备版本
const version = useragent.match(/cpu iphone os (.*?) like mac os/i);

if (!version) {
  FastClick.attach(document.body);
} else {
  /* eslint-disable */
  // ios 11 以上解决了 300ms 延迟
  if (parseInt(version[1]) < 11) {
    FastClick.attach(document.body);
  }
}

// document.oncontextmenu = ((e) => {
//   e.preventDefault();
// });

//软键盘关闭事件
document.body.addEventListener('focusout', utils.backToTop);


utils.Cookie.set('openid', utils.params('openid'));
import echarts from 'echarts';
import weui from 'weui.js';
Vue.prototype.$weui = weui;
Vue.prototype.$echarts = echarts;

Vue.http = axios.create({
  timeout: 10 * 1000,
});
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common.Authorization = utils.storage('token') || '';

Vue.config.productionTip = false;

Vue.directive('debounce', {
  bind(el, binding) {
    const eventName = 'touchend' in document ? 'touchend' : 'click';
    el.addEventListener(eventName, (e) => {
      // setTimeout 0 fix to IE 11
      setTimeout(() => {
        if (el.hasAttribute('disabled')) {
          e.preventDefault();
          return;
        }
        el.setAttribute('disabled', 'disabled');
        const fn = binding.value;
        const delay = 1000;
        if (fn) {
          fn();
        }
        setTimeout(() => {
          el.removeAttribute('disabled');
        }, delay);
      }, 0);
    });
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js